module.exports = __webpack_public_path__ + "static/bg_gold-37247f17d24aff0abc787473beb79aa1.jpg";